const ProjectRoutes = [
    {
      path: "/projects",
      name: "Projects",
      component: () => import("@/pages/projects/ProjectListPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Project'
        }
      },
      children: [
        {
          path: "new",
          name: "NewProject",
          component: () => import("@/pages/projects/NewProjectPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Project'
            }
          }
        },
      ]
    },
    {
      path: "/projects/:id",
      name: "OneProject",
      component: () => import("@/pages/projects/OneProjectPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Project'
        }
      },
      children: [
        // {
        //   path: "stages/:id",
        //   name: "OneStageDetails",
        //   component: () => import("@/pages/stages/OneStageDetailsPage.vue"),
        //   meta: {
        //     auth: true
        //   }
        // },
        // {
        //   path: "tasks/:id",
        //   name: "OneTaskDetails",
        //   component: () => import("@/pages/tasks/OneTaskDetailsPage.vue"),
        //   meta: {
        //     auth: true
        //   }
        // },
      ]
    }
  ]
  
  export default ProjectRoutes